export const fundManage = [
  {
    path: "/fundManage/WalletLimit",
    name: "WalletLimit",
    component: () => import("@/views/moneyManagement/walletLimit.vue"),
    meta: {
      title: "钱包额度",
      icon: "menu_circle",
      activeMenu: "/fundManage/WalletLimit",
      menuId: "noPermission",
      hidden: false,
    },
  },
  {
    path: "/fundManage/WalletFlow",
    name: "WalletFlow",
    component: () =>
      import("@/views/moneyManagement/walletTransacationFlow.vue"),
    meta: {
      title: "钱包流水",
      icon: "menu_circle",
      activeMenu: "/fundManage/WalletFlow",
      menuId: "noPermission",
      hidden: false,
    },
  },
  {
    path: "/fundManage/orderManagement",
    name: "orderManagement",
    component: () => import("@/views/moneyManagement/orderList.vue"),
    meta: {
      title: "订单管理",
      icon: "menu_circle",
      activeMenu: "/fundManage/orderManagement",
      menuId: "noPermission",
      hidden: false,
    },
  },
  {
    path: "/fundManage/orderDetail",
    name: "orderDetial",
    component: () => import("@/views/moneyManagement/orderDetail.vue"),
    meta: {
      title: "订单详情",
      activeMenu: "/fundManage/orderManagement",
      menuId: "noPermission",
      hidden: true,
      grade: 2,
      oneTitle: "订单管理",
    },
  },
  {
    path: "/fundManage/pay",
    name: "pay",
    component: () => import("@/views/moneyManagement/payMoney.vue"),
    meta: {
      title: "订单支付",
      activeMenu: "/fundManage/orderManagement",
      menuId: "noPermission",
      hidden: true,
    },
  },
  {
    path: "/fundManage/contractManagement",
    name: "contractManagement",
    component: () => import("@/views/moneyManagement/contractManagement.vue"),
    meta: {
      title: "合同管理",
      icon: "menu_circle",
      activeMenu: "/fundManage/managementInvoices",
      menuId: "1861283974680621142",
      hidden: false,
    },
  },
];
// 按钮code映射
export const productsBtnMap = {
  productExport_76426757: "1861283974676426757", // 商品管理-导出
};
